import instance from './instance';

export const destroyMeetingItemAttachment = attachmentId =>
  instance.delete(`/meeting_item_attachments/${attachmentId}`);
